/** Outlook 365 Calendar adapter — STUB. Implements CalendarPort. */
export function createOutlookCalendar() {
  const err = () => { throw new Error("OUTLOOK_CALENDAR_NOT_IMPLEMENTED"); };
  return {
    async status() { return { status: "not_connected", vendor: "outlook" }; },
    async findAvailableSlots() { err(); },
    async bookMeeting() { err(); },
    async cancelMeeting() { err(); },
    async listEvents() { err(); },
  };
}
